var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconDailyInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-daily-insights-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.94,1.15a1,1,0,0,0,0,2,9,9,0,1,1-7,3.38L6.34,8a7,7,0,1,0,5.6-2.81,1,1,0,0,0,0,2A5,5,0,1,1,7.78,9.4l1.45,1.45h0a2.91,2.91,0,0,0-.3,1.29,3,3,0,1,0,3-3,3,3,0,0,0-1.29.3h0L5.58,4.37h0l-.29-.29a1,1,0,0,0-1.41,0A1,1,0,0,0,3.61,5a11,11,0,1,0,8.33-3.82Zm0,10a1,1,0,1,1-1,1A1,1,0,0,1,11.94,11.15Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconDailyInsights);
export default __webpack_public_path__ + "static/media/navigation-icon-daily-insights.335a1247a36a18400b501f447debcb2e.svg";
export { ForwardRef as ReactComponent };